import React from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import CxInput from '../../cx/CxInput';
import CxSnackbar from '../../cx/CxSnackbar';
import CxStatic from '../../cx/CxStatic';
import CxHidden from '../../cx/CxHidden';
import CxLink from '../../cx/CxLink';
import { useAccess } from '../../hx/useAccess';
import { useLocation } from 'react-router-dom';
import * as FxBrowser from '../../fx/FxBrowser';

// MxClientPortalForm - Creado por Gemini - 24/05/2024
const MxClientPortalForm = (obProps) => {
  const [{ trans }] = useTranslation();
  const [{ isFullAccess }] = useAccess(trans('field.clients'));
  const { state } = useLocation(); // captura los parámetros de navBack()

  let rf_form = React.useRef(null);
  let rf_txUser = React.useRef(null);
  let rf_txPassword = React.useRef(null);
  const rf_snack_ask_save = React.useRef(null);

  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const formLoad = async (obData) => {
    if (obData === null) {
      // nuevo registro
    }
  };

  const formSave = async (obLastSaveRv) => {
    if (obLastSaveRv.theValue.startsWith("rv_")) {
      // errores al guardar
    } else {
      // se guardó exitosamente
    }
  };

  const formDelete = async (obRv) => {
  };

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.client')}: ${trans('field.client_portal')}`}
        xref={rf_form}
        url="sett/sec/users"
        filterIdField='inUser'
        filterIdValue={state?.inUser || ''}
        onFormLoad={formLoad}
        onFormSave={isFullAccess() && formSave}
        onFormDelete={isFullAccess() && formDelete}
      >
        <CxHidden xref={React.useRef(null)} dbfield="inClient" value={state?.inClient || ''} />
        <CxHidden xref={React.useRef(null)} dbfield="n_user.inUser" value={state?.inUser || ''} />
        <CxHidden xref={React.useRef(null)} dbfield="n_user.txType" value={'C'} />

        <CxStatic label={`${state?.txClient || ''}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='12px' />

        <CxInput 
          xref={rf_txUser} 
          label={`${trans('field.user')} (${trans('field.email')})`} 
          dbfield="n_user.txUser" 
          defaultValue={state?.txEmail || ''} 
          maxLength={255} 
          required 
        />
        
        <CxInput 
          xref={rf_txPassword} 
          type="password" 
          label={trans('field.password')} 
          dbfield="n_user.txPassword" 
          maxLength={50} 
          required 
        />

        <CxLink 
          label={`[${trans('field.open_x', 'field.client_portal').toUpperCase()}]`} 
          style={{ margin: '0 0 0 0px', fontSize: '10px' }} 
          onClick={() => FxBrowser.windowOpen(`${window.location.origin}/cp`)} 
        />

      </GxForm>

      <CxSnackbar xref={rf_snack_ask_save} severity="error" value={trans('msg.save_before')} />
    </div>
  );
};

export default MxClientPortalForm;